"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PHONE_INPUT_MASK = void 0;
exports.PHONE_INPUT_MASK = '(___) ___-____';
//# sourceMappingURL=masks.js.map